import { Typography } from "@suraasa/placebo-ui"

export const StatBox = ({
  label,
  value,
}: {
  label: string
  value: React.ReactNode
}) => (
  <div className="flex flex-col gap-1">
    <Typography variant="smallBody" className="text-onSurface-500">
      {label}
    </Typography>
    <Typography variant="title3" className="text-onSurface-900">
      {value}
    </Typography>
  </div>
)
